import type { CacheKey } from './internalTypings';

export const KeyNamespaces = {
    PAGINATION_ENTITY: 'luna/api/paginationEntities',
    PAGINATION: 'luna/api/pagination',
    MUTATION: 'luna/api/mutations',
    ENTITY: 'luna/api/entities',
    QUERIES: 'luna/api/queries',
};

export function getKey<PayloadArg>(
    namespace: string,
    options: {
        cacheKey?: CacheKey<PayloadArg>;
        name: string;
    },
    arg?: PayloadArg,
): string[] {
    const { cacheKey, name } = options;

    const namespaceIncludedInName = Object.values(KeyNamespaces).find((needleNamespace) =>
        name.startsWith(needleNamespace),
    );
    if (namespaceIncludedInName) {
        return [namespaceIncludedInName, name.replace(`${namespaceIncludedInName}/`, '')];
    }

    if (arg && cacheKey) {
        return [namespace, name, cacheKey(arg)];
    }

    return [namespace, name];
}
